export default {
  path: "/user/cpa/deportes",
  component: () =>
    import("@/views/user/cpa/deportes/DeportesLayout.vue"),
  meta: {
    requiresAuth: true,
    requiresCurso: true,
    requiresCpaDirectiva: true,
  },
  children: [
    {
      path: "",
      name: "deportes-delegados",
      component: () =>
        import("@/views/user/cpa/deportes/DelegadosView.vue"),
    },
    {
      path: "postulaciones",
      name: "deportes-postulaciones",
      component: () =>
        import("@/views/user/cpa/deportes/PostulacionesView.vue"),
    },
  ],
};
